<template lang="pug">
  .app
    router-view
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";

.app {  
  height: 100%;
}

</style>
